import React from 'react'
import packageJson from '../../package.json'
global.appVersion = packageJson.version
const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g)
  const versionsB = versionB.split(/\./g)
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift())
    const b = Number(versionsB.shift())
    // eslint-disable-next-line no-continue
    if (a === b) continue
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b)
  }
  return false
}
export class CacheBuster extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        if (window.caches) {
          // Service worker cache should be cleared with caches.delete()
          window.caches.keys().then(function (names) {
            // eslint-disable-next-line
            for (let name of names) window.caches.delete(name)
          })
        }
        // delete browser cache and hard reload
        window.location.reload()
      },
    }
  }
  componentDidMount() {
    fetch('/meta.json')
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version
        const currentVersion = global.appVersion
        const shouldForceRefresh = semverGreaterThan(
          latestVersion,
          currentVersion
        )
        if (shouldForceRefresh) {
          this.setState({ loading: false, isLatestVersion: false })
        } else {
          this.setState({ loading: false, isLatestVersion: true })
          global.appVersion = latestVersion
        }
      })
  }
  render() {
    // @ts-ignore
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state
    // @ts-ignore
    return this.props.children({
      loading,
      isLatestVersion,
      refreshCacheAndReload,
    })
  }
}
